import React from 'react';
import {makeStyles} from '@material-ui/core/styles'


const useStyles=makeStyles((themes)=>({

    svg2:{
        width:"100%",
        [themes.breakpoints.down('xs')]: {
            paddingTop:"50px"
          },
      
    }
    }));
export default function Path2(){
  const classes =useStyles();

    return(
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" className={classes.svg2} viewBox="0 0 1024.4 100">
  <g id="path2" transform="translate(-90.2)">
    <g id="Group_3" data-name="Group 3">
      <circle id="Ellipse_1" cx="10.1" cy="10.1" r="10.1" transform="translate(90.2 0)" fill="#3c70a5"/>
      <circle id="Ellipse_2" cx="7.8" cy="7.8" r="7.8" transform="translate(92.5 2.3)" fill="#fff"/>
    </g>
    <rect id="Rectangle_1" width="456.5" height="1.4" transform="translate(100.3 53.9)" fill="#3c70a5"/>
    <rect id="Rectangle_1_1_" width="2.1" height="35.1" transform="translate(99.2 20.1)" fill="#3c70a5"/>
    <rect id="Rectangle_1_2_" width="456.5" height="1.4" transform="translate(641.8 53)" fill="#3c70a5"/>
    <g id="Group_4" data-name="Group 4">
      <circle id="Ellipse_1_1_" cx="7.6" cy="7.6" r="7.6" transform="translate(1099.4 45.7)" fill="#3c70a5"/>
      <circle id="Ellipse_2_1_" cx="5.9" cy="5.9" r="5.9" transform="translate(1101.1 47.4)" fill="#fff"/>
    </g>
    <rect id="Rectangle_1_3_" width="1.3" height="39" transform="translate(1106.6 61)" fill="#3c70a5"/>
    <g id="Group_10" data-name="Group 10">
      <g id="Group_9" data-name="Group 9">
        <path id="Path_2" data-name="Path 2" d="M612.7,42H589.6V65.1h23.1Z" fill="#054f97"/>
        <g id="Group_5" data-name="Group 5">
          <path id="Path_3" data-name="Path 3" d="M616,46h4.1a1.4,1.4,0,1,0,0-2.8H616a1.367,1.367,0,0,0-1.4,1.4A1.43,1.43,0,0,0,616,46Z" fill="#054f97"/>
          <path id="Path_4" data-name="Path 4" d="M620.2,49.2H616a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.347,1.347,0,0,0,620.2,49.2Z" fill="#054f97"/>
          <path id="Path_5" data-name="Path 5" d="M620.2,55.1H616a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.347,1.347,0,0,0,620.2,55.1Z" fill="#054f97"/>
          <path id="Path_6" data-name="Path 6" d="M620.2,61H616a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.347,1.347,0,0,0,620.2,61Z" fill="#054f97"/>
        </g>
        <g id="Group_6" data-name="Group 6">
          <path id="Path_7" data-name="Path 7" d="M593.7,38.7V34.6a1.4,1.4,0,0,0-2.8,0v4.1a1.367,1.367,0,0,0,1.4,1.4A1.593,1.593,0,0,0,593.7,38.7Z" fill="#054f97"/>
          <path id="Path_8" data-name="Path 8" d="M596.8,34.5v4.1a1.4,1.4,0,0,0,2.8,0V34.5a1.367,1.367,0,0,0-1.4-1.4A1.43,1.43,0,0,0,596.8,34.5Z" fill="#054f97"/>
          <path id="Path_9" data-name="Path 9" d="M602.7,34.5v4.1a1.4,1.4,0,0,0,2.8,0V34.5a1.367,1.367,0,0,0-1.4-1.4A1.43,1.43,0,0,0,602.7,34.5Z" fill="#054f97"/>
          <path id="Path_10" data-name="Path 10" d="M608.6,34.5v4.1a1.4,1.4,0,0,0,2.8,0V34.5a1.367,1.367,0,0,0-1.4-1.4A1.43,1.43,0,0,0,608.6,34.5Z" fill="#054f97"/>
        </g>
        <g id="Group_7" data-name="Group 7">
          <path id="Path_11" data-name="Path 11" d="M593.7,72.5V68.4a1.4,1.4,0,0,0-2.8,0v4.1a1.367,1.367,0,0,0,1.4,1.4A1.43,1.43,0,0,0,593.7,72.5Z" fill="#054f97"/>
          <path id="Path_12" data-name="Path 12" d="M596.8,68.4v4.1a1.4,1.4,0,0,0,2.8,0V68.4a1.4,1.4,0,0,0-2.8,0Z" fill="#054f97"/>
          <path id="Path_13" data-name="Path 13" d="M602.7,68.4v4.1a1.4,1.4,0,0,0,2.8,0V68.4a1.4,1.4,0,0,0-2.8,0Z" fill="#054f97"/>
          <path id="Path_14" data-name="Path 14" d="M608.6,68.4v4.1a1.4,1.4,0,0,0,2.8,0V68.4a1.4,1.4,0,0,0-2.8,0Z" fill="#054f97"/>
        </g>
        <g id="Group_8" data-name="Group 8">
          <path id="Path_15" data-name="Path 15" d="M582.1,46h4.1a1.4,1.4,0,1,0,0-2.8h-4.1a1.367,1.367,0,0,0-1.4,1.4A1.43,1.43,0,0,0,582.1,46Z" fill="#054f97"/>
          <path id="Path_16" data-name="Path 16" d="M586.3,49.2h-4.1a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.5,1.5,0,0,0,586.3,49.2Z" fill="#054f97"/>
          <path id="Path_17" data-name="Path 17" d="M586.3,55.1h-4.1a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.5,1.5,0,0,0,586.3,55.1Z" fill="#054f97"/>
          <path id="Path_18" data-name="Path 18" d="M586.3,61h-4.1a1.4,1.4,0,1,0,0,2.8h4.1a1.367,1.367,0,0,0,1.4-1.4A1.43,1.43,0,0,0,586.3,61Z" fill="#054f97"/>
        </g>
      </g>
    </g>
  </g>
</svg>


        </div>
    )
}